import { ReportBodySkeleton } from '../app-layout-skeleton'

// No box of its own: this stands in for ReportComponent INSIDE the pane, and the skeleton's root already
// carries the report body's own `@container mx-auto max-w-7xl` column.
export function NestedReportPending() {
  return <ReportBodySkeleton />
}
